import axios from "axios";

let api_key = 'AIzaSyDsVz9JxA54QK2Qq4W7Dlqj7FK3fvT5VnI'//process.env.VUE_APP_API_URL;

export default {

    async getYTStats(embedId) {
        var instance = axios.create();
        delete instance.defaults.headers.common['Authorization'];
        let response = await instance.get("https://www.googleapis.com/youtube/v3/videos?part=statistics&id=" + embedId + "&key=" + api_key);
       
        if (response.data.items[0]) {
            let stats = response.data.items[0].statistics;
            return stats
        }

        return null;
    },


    async getVideoDuration(embedId) {
        var instance = axios.create();
        delete instance.defaults.headers.common['Authorization'];
        let response = await instance.get("https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=" + embedId + "&key=" + api_key);
        if (response.data.items.length) {
            let durationSecs = this.convertToSeconds(response.data.items[0].contentDetails.duration);

            return { duration: durationSecs, error: false };
        } else {
            return { duration: 0, error: true };
        }
    },

    convertToSeconds(duration) {
        var a = duration.match(/\d+/g);

        if (duration.indexOf('M') >= 0 && duration.indexOf('H') == -1 && duration.indexOf('S') == -1) {
            a = [0, a[0], 0];
        }

        if (duration.indexOf('H') >= 0 && duration.indexOf('M') == -1) {
            a = [a[0], 0, a[1]];
        }
        if (duration.indexOf('H') >= 0 && duration.indexOf('M') == -1 && duration.indexOf('S') == -1) {
            a = [a[0], 0, 0];
        }

        duration = 0;

        if (a.length == 3) {
            duration = duration + parseInt(a[0]) * 3600;
            duration = duration + parseInt(a[1]) * 60;
            duration = duration + parseInt(a[2]);
        }

        if (a.length == 2) {
            duration = duration + parseInt(a[0]) * 60;
            duration = duration + parseInt(a[1]);
        }

        if (a.length == 1) {
            duration = duration + parseInt(a[0]);
        }
        return duration;
    }
}